<template>
  <v-card>
    <v-card-title class="py-3">
      <v-avatar
        class="pointer"
        size="36px"
        color="primary"
        @click="gotoProfile"
      >
        <v-img
          v-if="trade_data.user_image"
          alt="Avatar"
          :src="getImg(trade_data.user_image)"
        />
        <span class="white--text text-body-2" v-else>
          {{ trade_data.posted_by_name | reduceToInitials }}
        </span>
      </v-avatar>
      <v-col cols="6" class="ms-2 text-body-1 pe-0">
        <b class="" style="cursor: pointer" @click="gotoProfile">
          {{ trade_data.posted_by_name }}
        </b>
        <img
          @mouseover="tooltip = true"
          @mouseout="tooltip = false"
          id="sebi-badge"
          :src="sebi_badge"
          alt=""
          v-if="trade_data.is_sebi_registered"
          style="margin-bottom: -5px"
        />
        <p id="sebi-tooltip" v-if="tooltip">SEBI Registered</p>

        <span
          style="color: rgba(51, 51, 51, 0.54)"
          class="d-block text-caption"
          v-if="trade_data.created"
        >
          {{ trade_data.created | formatTimestamp }}
        </span>
      </v-col>
      <v-spacer />
      <v-col class="pa-0" cols="4" align="end">
        <div v-if="!is_same_user">
          <v-btn
            small
            class="px-6 py-3"
            color="primary"
            :text="is_followed"
            @click="
              is_followed
                ? unFollowUser(trade_data.posted_by_id)
                : followUser(trade_data.posted_by_id)
            "
          >
            <span
              style="font-weight: 800; font-size: 14px"
              class="text-capitalize"
            >
              {{ is_followed ? "Following" : "Follow" }}
            </span>
          </v-btn>
        </div>
      </v-col>
    </v-card-title>
    <v-divider />
    <v-card-text class="pt-3">
      <v-row class="ma-0">
        <v-col class="font-weight-bold black--text" style="font-size: 15px">
          <div @click="goToSecurityDetailPage(trade_data)">
            {{ trade_data.security_name }}
          </div>
        </v-col>

        <v-chip :class="setChipClass"
          ><span style="color: #eb5757">{{ tradeStatusText }}</span>
          <v-tooltip
            content-class="tooltip"
            color="#F7FAFF"
            right
            max-width="300"
          >
            <template
              v-slot:activator="{ on, attrs }"
              style="opacity: 1 !important"
            >
              <v-icon
                :color="infoIconColor"
                class="pl-2"
                small
                v-bind="attrs"
                v-on="on"
                >mdi-information-outline</v-icon
              >
            </template>
            <span class="tooltip-text">{{ statusContent }}<br /></span>
          </v-tooltip>
        </v-chip>

        <!-- <v-btn color="error" text class="text-capitalize font-weight-bold">
          <v-icon class="mt-n2" dark> mdi-music-note-whole </v-icon>
          closed
          <v-icon right dark> mdi-information-outline </v-icon>
        </v-btn> -->
      </v-row>
      <v-row class="ma-0 mt-4">
        <v-col>
          <div class="text-caption" style="color: rgba(51, 51, 51, 0.54)">
            Entry Price
          </div>
          <div class="font-weight-bold text-subtitle-1 black--text">
            ₹{{ trade_data.entry_price.toFixed(2) }}
          </div>
        </v-col>
        <v-col class="text-center">
          <div class="text-caption" style="color: rgba(51, 51, 51, 0.54)">
            Exit Price
          </div>
          <div class="font-weight-bold text-subtitle-1 black--text">
            ₹{{ trade_data.closing_live_price.toFixed(2) }}
          </div>
        </v-col>
        <v-col class="text-right">
          <div class="text-caption" style="color: rgba(51, 51, 51, 0.54)">
            Realised P&L
          </div>
          <div>
            <v-chip
              class="font-weight-bold"
              color="#DCF2E5"
              style="color: #27ae60"
            >
              {{ Math.abs(trade_data.pl_percent) }}%
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import Axios from "@/api/BaseAxios.js";
import { isAuthenticated } from "../../../common/commonFunctions.js";
import { getImgLink } from "@/common/commonFunctions.js";

export default {
  props: ["trade_data", "is_followed"],
  data: () => ({
    tooltip: false,
    sebi_badge: require("@/assets/images/gold_check.svg"),
    // isFollowingUser: this.trade_data.is_following_user,
  }),
  computed: {
    isFollowingUser() {
      return this.trade_data.is_following_user;
    },
    is_same_user() {
      const user_id = localStorage.getItem("user_id");
      return Number(user_id) === Number(this.trade_data.posted_by_id);
    },
    infoIconColor() {
      if (this.trade_data.status == "Active") {
        return "#27ae60";
      } else if (this.trade_data.status == "Inactive") {
        return "#2f80ed";
      } else if (this.trade_data.status == "Closed") {
        return "#eb5757";
      } else {
        return "#f2f2f2";
      }
    },
    tradeStatusText() {
      if (this.trade_data.status == "Active") {
        return "Live";
      } else if (this.trade_data.status == "Inactive") {
        return "Upcoming";
      } else {
        return this.trade_data.status;
      }
    },
    statusContent() {
      if (this.trade_data.status == "Active") {
        return "This is a live trade. Market entry was done on the Entry Price. Hold until Exit Price. Book profit/Cut loss on Target Price/Stop Loss";
      } else if (this.trade_data.status == "Inactive") {
        return "This is an upcoming trade and is not Live yet. Market entry to be done on the Entry Price.";
      } else {
        return "This is a past trade";
      }
    },
    setChipClass() {
      return "chip-" + this.trade_data.status;
    },
  },
  methods: {
    ...mapActions("snackBar", ["showSnack"]),
    getImg(link) {
      return getImgLink(link);
    },
    gotoProfile() {
      this.$router.push({
        name: "OthersProfilePage",
        params: {
          id: this.trade_data.posted_by_id,
          name: this.trade_data.posted_by_name,
        },
      });
    },
    followUser(to_follow_id) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to follow another User",
          color: "success",
          timeout: 4500,
        });
        return false;
      }
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.$emit("reloadTradeDetailForm", this.trade_data.id);
        this.is_followed = true;
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$logEvent("followed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_followed_profile");
        }
      };
      const data = {
        user_id: user_id,
        to_follow_id: to_follow_id,
      };
      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "success",
          timeout: 4500,
        });
      };
      Axios.request_POST(
        "/api/follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    unFollowUser(to_unfollow_id) {
      if (!isAuthenticated()) {
        this.showSnack({
          text: "Login to follow another User",
          color: "success",
          timeout: 4500,
        });
        return false;
      }
      const user_id = localStorage.getItem("user_id");
      const successHandler = (res) => {
        this.$emit("reloadTradeDetailForm", this.trade_data.id);
        this.is_followed = false;
        this.showSnack({
          text: `${res.data.message}`,
          color: "success",
          timeout: 4500,
        });
        this.$logEvent("unfollowed_profile");
        if (this.$vuetify.breakpoint.xsOnly) {
          this.$logEvent("mweb_unfollowed_profile");
        }
      };
      const data = {
        user_id: user_id,
        to_unfollow_id: to_unfollow_id,
      };
      const errorHandler = (err) => {
        this.showSnack({
          text: `${err.data.message}`,
          color: "success",
          timeout: 4500,
        });
      };
      Axios.request_POST(
        "/api/un-follow-influencer/",
        data,
        {},
        successHandler,
        errorHandler,
        false,
        false
      );
    },
    goToSecurityDetailPage(trade_data) {
      this.$router.push(
        `/search/${trade_data.security_name}-${trade_data.security_exchange}`
      );
    },
  },
};
</script>

<style>
.chip-Inactive,
.chip-Closed,
.chip-Active {
  font-size: 12px !important;
}

.chip-Inactive {
  background: rgba(47, 128, 237, 0.2) !important;
  font-size: 14px;
  color: #2f80ed;
}
.chip-Closed {
  background: rgba(235, 87, 87, 0.2) !important;
  color: #eb5757;
}
.chip-Active {
  color: #27ae60;
  background: #ddeee8 !important;
  border-radius: 24px;
}
.tooltip-text {
  color: #333333 !important;
}
</style>
